import type { Questionnaire } from '@medplum/fhirtypes'
import {
  VALIDATED_TOOL_SUMMARY_ITEM,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

export const slumsQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/SLUMS',
  title: 'St. Louis University Mental Status (SLUMS) Examination [SLUMS]',
  name: 'SLUMS',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  code: [
    {
      system: 'http://loinc.org',
      code: '71947-6',
      display: 'St. Louis University Mental Status (SLUMS) Examination [SLUMS]',
    },
  ],
  item: [
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://www.slu.edu/medicine/internal-medicine/geriatric-medicine/aging-successfully/-pdf/slums-form.pdf',
        },
      ],
    },
    {
      type: 'decimal',
      code: [
        {
          code: '71492-3',
          display: 'Total score',
          system: 'http://loinc.org',
        },
      ],
      extension: [
        {
          url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-unit',
          valueCoding: {
            code: '{score}',
            display: '{score}',
            system: 'http://unitsofmeasure.org',
          },
        },
      ],
      linkId: '/71492-3',
      text: 'Total score',
    },
    VALIDATED_TOOL_SUMMARY_ITEM,
  ],
} satisfies Questionnaire
